import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import Breadcrumbs from "../components/Breadcrumbs";
import Button from "../components/Button";
import Pagination from "../components/Pagination";
import Table from "../components/table";
import EditIcon from "@mui/icons-material/Edit";
import * as bootstrap from "bootstrap";
 
const MyWarehouses = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
 
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
 
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [newBaseRate, setNewBaseRate] = useState("");
  const [error, setError] = useState("");
 
  const navigate = useNavigate();
 
  // Fetch Warehouses
  useEffect(() => {
    const fetchWarehouse = async () => {
      try {
        const response = await api.get("/wh-owner/my-warehouses");
        setEnquiries(response.data.warehouses || []);
      } catch (error) {
        console.error("Failed to fetch warehouse:", error);
        setEnquiries([]);
      } finally {
        setLoading(false);
      }
    };
    fetchWarehouse();
  }, []);
 
  // Open Edit Base Rate Modal
  const openEditModal = (wh) => {
    setSelectedWarehouse(wh);
    setNewBaseRate(wh.base_rate || "");
    setError("");
 
    const modal = new bootstrap.Modal(document.getElementById("editRateModal"));
    modal.show();
  };
 
  // Save Base Rate
  const handleSave = async () => {
    if (!newBaseRate.trim()) {
      setError("Base Price is required");
      return;
    }
 
    try {
      await api.put(`/wh-owner/update-base-rate/${selectedWarehouse.id}`, {
        base_rate: newBaseRate,
      });
 
      setEnquiries((prev) =>
        prev.map((item) =>
          item.id === selectedWarehouse.id
            ? { ...item, base_rate: newBaseRate }
            : item
        )
      );
 
      const modal = bootstrap.Modal.getInstance(
        document.getElementById("editRateModal")
      );
      modal.hide();
    } catch (error) {
      console.error("Failed to update Base Rate:", error);
      setError("Failed to update Base Rate!");
    }
  };
 
  // Pagination logic
  const totalItems = enquiries.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = enquiries.slice(startIndex, startIndex + itemsPerPage);
 
  const goToPage = (page) => {
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;
    setCurrentPage(page);
  };
 
  const handleItemsPerPageChange = (num) => {
    setItemsPerPage(num);
    setCurrentPage(1);
  };
 
  // Initialize Bootstrap tooltips
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
 
 
     const tooltipList = [...tooltipTriggerList].map(
        (el) =>
          new bootstrap.Tooltip(el, {
            trigger: "hover",
          })
      );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, [currentItems]);
 
  // Table columns
  const columns = [
    { label: "Warehouse Name", accessor: "name" },
    { label: "Base Price", accessor: "base_rate" },
    { label: "Location/City", accessor: "location_city" },
    {
      label: "Address",
      render: (wh) => (
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={
            wh.address_line1
              ? `${wh.address_line1}${wh.address_line2 ? ", " + wh.address_line2 : ""}`
              : wh.address1
              ? `${wh.address1}${wh.address2 ? ", " + wh.address2 : ""}`
              : "No Address Found"
          }
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "inline-block",
            maxWidth: "180px",
            cursor: "pointer",
          }}
        >
          {wh.address_line1
            ? `${wh.address_line1}${wh.address_line2 ? ", " + wh.address_line2 : ""}`
            : wh.address1
            ? `${wh.address1}${wh.address2 ? ", " + wh.address2 : ""}`
            : "—"}
        </span>
      ),
    },
    { label: "Status", accessor: "status" },
    {
      label: "Action",
      render: (wh) =>
        wh.status === "Active" ? (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => openEditModal(wh)}
          >
            <EditIcon style={{ fontSize: "20px", color: "#8393a2" }} />
          </div>
        ) : (
          <div style={{ cursor: "default" }} />
        ),
    },
  ];
 
  return (
    <>
      {loading ? (
        <p>Loading My Warehouse...</p>
      ) : (
        <>
          <Breadcrumbs />
 
          <div className="d-flex justify-content-end mb-2">
            <Button
              size="md"
              btncls="mt-0 text-white"
              style={{ backgroundColor: "#1d3160", borderColor: "#1d3160" }}
              onClick={() => navigate("/create-warehouse")}
            >
              + Add New Warehouse
            </Button>
          </div>
 
          <Table
            columns={columns}
            data={currentItems}
            loading={loading}
            emptyMessage="No My Warehouse List found."
            itemsPerPage={itemsPerPage}
            pagination={
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={totalItems}
                onPageChange={goToPage}
                itemsPerPage={itemsPerPage}
                onItemsPerPageChange={handleItemsPerPageChange}
              />
            }
          />
 
          {/* Edit Base Rate Modal */}
          <div
            className="modal fade"
            id="editRateModal"
            tabIndex="-1"
            aria-labelledby="editRateModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Base Price</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
 
                <div className="modal-body">
                  <label className="fw-bold mb-2">Enter New Base Price</label>
                  <input
                    type="number"
                    className="form-control"
                    value={newBaseRate}
                    onChange={(e) => setNewBaseRate(e.target.value)}
                  />
 
                  {error && (
                    <p className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      {error}
                    </p>
                  )}
                </div>
 
                <div className="modal-footer">
                  <Button variant="secondary" data-bs-dismiss="modal">
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    style={{ background: "#1d3160", borderColor: "#1d3160" }}
                    onClick={handleSave}
                  >
                    Save Changes
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
 
export default MyWarehouses;